<p-toast></p-toast>

<div *ngIf="accessDenied" class="p-m-3">Access Denied</div>

<div *ngIf="!accessDenied" class="p-m-3">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <button
        pButton
        label="Make VIP Selected"
        icon="pi pi-check"
        (click)="makeVipSelected()"
        [disabled]="!selectedUsers.length"
      ></button>
      <button
        pButton
        label="Remove VIP Selected"
        icon="pi pi-times"
        class="p-button-danger"
        (click)="removeVipSelected()"
        [disabled]="!selectedUsers.length"
      ></button>
    </div>
  </p-toolbar>

  <div *ngIf="loading" class="text-center my-5">
    <span class="spinner-border" role="status"></span>
  </div>
  <p-table
    *ngIf="!loading"
    #dt
    [value]="users"
    [(selection)]="selectedUsers"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    sortMode="multiple"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th pSortableColumn="name">
          Full Name <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="username">
          Username <p-sortIcon field="username"></p-sortIcon>
        </th>
        <th>Phone Number</th>
        <th>Email</th>
        <th>Email Verified</th>
        <th>VIP Status</th>
        <th>VIP Note</th>
        <th>Actions</th>
        <th>Approve Email</th>
      </tr>
      <tr>
        <th></th>
        <th>
          <input
            pInputText
            type="text"
            (input)="dt.filter($any($event.target).value, 'name', 'contains')"
          />
        </th>
        <th>
          <input
            pInputText
            type="text"
            (input)="
              dt.filter($any($event.target).value, 'username', 'contains')
            "
          />
        </th>
        <th></th>
        <th>
          <input
            pInputText
            type="text"
            (input)="dt.filter($any($event.target).value, 'email', 'contains')"
          />
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-user
      let-columns="columns"
      let-rowIndex="rowIndex"
    >
      <tr>
        <td>
          <p-tableCheckbox [value]="user"></p-tableCheckbox>
        </td>
        <td>{{ user.name }} {{ user.last_name }}</td>
        <td>{{ user.username }}</td>
        <td>
          <a [href]="'tel:' + getPhone(user.id)">{{ getPhone(user.id) }}</a>
        </td>
        <td>{{ user.email }}</td>
        <td>
          <p-tag
            [severity]="emailSeverity(user)"
            [value]="user.email_verified ? 'Verified' : 'Not Verified'"
          ></p-tag>
        </td>
        <td>
          <p-tag
            [severity]="adminSeverity(user)"
            [value]="user.isVip ? 'VIP' : 'Not VIP'"
          ></p-tag>
        </td>
        <td>{{ user.vipNote || "" }}</td>
        <td>
          <button
            pButton
            icon="pi pi-check"
            class="p-button-text"
            *ngIf="!user.isVip"
            (click)="makeVip(user.id)"
          ></button>
          <button
            pButton
            icon="pi pi-times"
            class="p-button-text p-button-danger"
            *ngIf="user.isVip"
            (click)="removeVip(user.id)"
          ></button>
        </td>
        <td>
          <button
            pButton
            icon="pi pi-envelope"
            class="p-button-text"
            (click)="approveEmail(user.id)"
            [disabled]="user.email_verified"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    header="VIP Note"
    [(visible)]="vipDialogVisible"
    [modal]="true"
    [closable]="false"
  >
    <div class="p-field">
      <label for="vipNote">VIP Note (optional)</label>
      <input id="vipNote" type="text" pInputText [(ngModel)]="vipNoteText" />
    </div>
    <p-footer>
      <button
        pButton
        label="Cancel"
        icon="pi pi-times"
        class="p-button-text"
        (click)="vipDialogVisible=false"
      ></button>
      <button
        pButton
        label="Submit"
        icon="pi pi-check"
        (click)="submitVip()"
      ></button>
    </p-footer>
  </p-dialog>
</div>
